import { useNavigate } from "react-router-dom";

const HiringBanner = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      backgroundColor: "#0066b3",
      color: "#fff",
      padding: "40px 45px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderRadius: "0px",
      marginTop: "40px",
      flexWrap: "wrap",
    }}>
      <div style={{ flex: 1, minWidth: 250 }}>
        <p style={{ margin: 0, fontSize: "18px", color:"white" }}>Interested in working with us?</p>
        <h2 style={{ margin: "5px 0 0", fontSize: "28px", color:"white", fontWeight: "bold" }}>WE ARE HIRING RIGHT NOW!</h2>
      </div>

      <button
        onClick={() => navigate("/careers")}
        style={{
          padding: "12px 28px",
          backgroundColor: "#ffffff",
          color: "#0066b3",
          fontSize: "16px",
          fontWeight: "600px",
          borderRadius: "30px",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          marginTop: "10px"
        }}
      >
        Explore Opportunities
      </button>
    </div>
  );
};

export default HiringBanner;
